import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalBody,
	Alert,
	Box,
	ModalFooter,
	Button,
	AlertTitle,
	AlertIcon,
	AlertDescription,
	useDisclosure,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SectionViewModel } from "./section.view-model";
import { useContext } from "react";
import { ButtonDelete } from "components/elements/buttons/button-delete";
import { useState } from "react";
import { AlertsContext } from "providers/alerts";
import { apiRequest } from "utils/api";
import { getErrorMessage } from "utils/errorHandler";

interface SectionDeleteButtonProps {
	section: SectionViewModel;
	onDelete: (section: SectionViewModel) => void;
}

export function SectionDeleteButton({
	section,
	onDelete,
}: SectionDeleteButtonProps) {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { showSuccess, showError } = useContext(AlertsContext);

	const [loading, setLoading] = useState(false);

	async function handleOnDeleteSection() {
		if (section.id) {
			try {
				setLoading(true);

				await apiRequest("/supabase/loan_section/delete", {
					sectionId: section.id,
				});
			} catch (error) {
				showError({
					title: "Could Not delete Loan Sections",
					description: getErrorMessage(error),
				});
				return;
			} finally {
				setLoading(false);
			}
		}

		showSuccess({
			title: "Section Deleted",
			description: "Section was successfully deleted",
		});

		onClose();
		onDelete(section);
	}

	return (
		<>
			<ButtonDelete onClick={onOpen} float="right">
				Delete Section
			</ButtonDelete>

			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius="16px">
					<ModalBody p={6}>
						<Alert status="error" borderRadius="8px">
							<AlertIcon />
							<Box>
								<AlertTitle>Delete Section {section.section_name}?</AlertTitle>
								<AlertDescription>
									Deleting a loan section will delete all loan fields and
									section itself.
								</AlertDescription>
							</Box>
						</Alert>
					</ModalBody>

					<ModalFooter gap={2} pt={0} pb={6}>
						<Button variant="outline" onClick={onClose}>
							Cancel
						</Button>
						<Button
							leftIcon={<FontAwesomeIcon icon={["far", "trash-alt"]} />}
							variant="red"
							onClick={handleOnDeleteSection}
							isLoading={loading}
						>
							Confirm
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}
